import React from 'react'
import PropTypes from 'prop-types'
import BaseComponent from '@base/BaseComponent'
import CSS from './index.module.css'
import arrowDown from '@assets/icon/arrow_down.png'
import arrowUp from '@assets/icon/arrow_up.png'
import { _ } from '@iskytrip/sdk'

// 预订页面PayBar
class GLPayBar extends BaseComponent {
	static propTypes = {
		showPrice: PropTypes.bool,
		price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
		showDetail: PropTypes.bool,
		detailsArray: PropTypes.array,
		submitText: PropTypes.string,
		disabled: PropTypes.bool,
		btnStyle: PropTypes.object,
		commit: PropTypes.func,
	}

	static defaultProps = {
		showPrice: true,
		price: 0,
		showDetail: true,
		detailsArray: [],
		submitText: '立即预订',
		disabled: false,
		btnStyle: {},
		commit: () => {},
	}

	constructor(props) {
		super(props)
		this.bsScroll = null
		this.state = {
			isShowInfo: false,
		}
	}

	toggleAlert() {
		let isShow = !this.state.isShowInfo
		this.setState({
			isShowInfo: isShow,
		})
	}

	commit() {
		!this.props.disabled && this.props.commit && this.props.commit()
	}

	render() {
		let {
			showPrice,
			price,
			showDetail,
			detailsArray,
			submitText,
			disabled,
			specialTag,
			btnStyle,
		} = this.props

		return (
			<div className={CSS.section}>
				<div className={CSS.button}>
					{showPrice ? (
						<div className={CSS.buttonLeft}>
							<div className={CSS.buttonLeftInner1}>
								<p>￥</p>
								<p>{(price.toFixed && price.toFixed(2)) || price || '--'}</p>
							</div>
							{_.isHasValue(specialTag) ? (
								<div className={CSS.buttonLeftInner2}>{specialTag}</div>
							) : null}
						</div>
					) : null}
					<div className={CSS.buttonRight}>
						{showDetail ? (
							<>
								<p onClick={this.toggleAlert.bind(this)}>明细</p>
								<img
									src={this.state.isShowInfo ? arrowUp : arrowDown}
									onClick={this.toggleAlert.bind(this)}
									alt=''
								/>
							</>
						) : (
							<>
								<p></p>
								<p></p>
							</>
						)}
						<p
							onClick={this.commit.bind(this)}
							className={disabled ? CSS.disabledBtn : CSS.btn}
							style={btnStyle}
						>
							{submitText}
						</p>
					</div>
				</div>

				{this.state.isShowInfo ? (
					<div className={CSS.mask} onClick={this.toggleAlert.bind(this)}></div>
				) : null}

				{this.state.isShowInfo ? (
					<div className={CSS.infoSection}>
						{detailsArray.map((item, index) => {
							// item.orderPriceDetailImg = 'https://publicdev.oss-cn-beijing.aliyuncs.com/icon/common/seckill_tag2.png'

							return (
								<div key={index} className={CSS.cell}>
									<p className={CSS.cellLeft}>{item.label}</p>
									<p className={CSS.cellRight} style={{ color: item.color }}>
										{item.value}
									</p>
									{_.isHasValue(item.tagImg) ? (
										<img className={CSS.tagImg} src={item.tagImg} alt='' />
									) : null}
								</div>
							)
						})}
					</div>
				) : null}
			</div>
		)
	}
}

export default GLPayBar
